import { LearningGroup } from '../../services/learningGroupService';

export const confirmLeaveGroup = (group: Pick<LearningGroup, 'name' | 'isPublic'>): boolean =>
    window.confirm(
        `Wirklich aus der Lerngruppe „${group.name}" austreten? `
        + 'Ihre Mitgliedschaft endet damit, der Gruppenchat ist für Sie nicht mehr sichtbar. '
        + (group.isPublic
            ? 'Sie können der Gruppe später erneut beitreten.'
            : 'Die Gruppe ist nur auf Einladung offen — ein Gruppen-Admin muss Sie erneut hinzufügen.')
    );
